import { createAsyncAction, createAction } from 'utils/actions';

export const FETCH_ORDER = createAsyncAction('FETCH_ORDER');
export const FETCH_ORDERS = createAsyncAction('FETCH_ORDERS');
export const REORDER_ORDER = createAsyncAction('REORDER_ORDER');
export const DELETE_ORDER = createAsyncAction('DELETE_ORDER');
export const SET_ORDER_LOAD_MORE = createAction('SET_ORDER_LOAD_MORE');
export const ASSIGN_ORDERS = createAction('ASSIGN_ORDERS');
export const INVOICE_ORDER = createAsyncAction('INVOICE_ORDER');